import {Redirect, Route, Switch} from 'react-router-dom';
import {LAUNCH_DATE} from 'src/constants';
import {useAddress, useWorldTime} from 'src/hooks';
import Art from './Art';
import Artist from './Artist';
import LaunchCountdown from './LaunchCountdown';
import Tos from './Tos';
import Explore from './explore';
import HybridsCreate from './hybrids/Create';
import Me from './me';
import ProfilesShow from './profiles/Show';

const OWNER = '0xf9eB1f63710BA1D2D741f9742438FAF54078f1C7'.toLowerCase();

export default function ViewsRoutes() {
  const time = useWorldTime();
  const address = useAddress();

  return (
    <Switch>
      <Route path='/tos'>
        <Tos />
      </Route>
      {(time && time >= LAUNCH_DATE.getTime()) || (address && address.toLowerCase() === OWNER) ? (
        <Switch>
          <Route path='/me'>
            <Me />
          </Route>

          <Route path='/explore'>
            <Explore />
          </Route>

          <Route path='/hybrids/:contentId/create'>
            <HybridsCreate />
          </Route>

          <Route path='/profiles/:address'>
            <ProfilesShow />
          </Route>

          <Route path={['/arts/:id', '/art']}>
            <Art />
          </Route>

          <Route path={['/artists/:id', '/artist']}>
            <Artist />
          </Route>

          <Redirect to='/me' />
        </Switch>
      ) : (
        <Route>
          <LaunchCountdown />
        </Route>
      )}
    </Switch>
  );
}
